module.exports = __webpack_public_path__ + "img/excel_icon.c6d3f056.svg";